module.exports = __webpack_public_path__ + "static/media/dropdown-white-select.15c63ba6.svg";